"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiquidityHelper__factory = void 0;
var ethers_1 = require("ethers");
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_pool",
                type: "address",
            },
            {
                internalType: "int24",
                name: "_tickLower",
                type: "int24",
            },
            {
                internalType: "int24",
                name: "_tickUpper",
                type: "int24",
            },
            {
                internalType: "uint128",
                name: "_liquidity",
                type: "uint128",
            },
        ],
        name: "getAmountsForLiquidity",
        outputs: [
            {
                internalType: "uint256",
                name: "amount0",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amount1",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_pool",
                type: "address",
            },
            {
                internalType: "int24",
                name: "_tickLower",
                type: "int24",
            },
            {
                internalType: "int24",
                name: "_tickUpper",
                type: "int24",
            },
            {
                internalType: "uint256",
                name: "_amount0",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_amount1",
                type: "uint256",
            },
        ],
        name: "getLiquidityForAmounts",
        outputs: [
            {
                internalType: "uint128",
                name: "liquidity",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var LiquidityHelper__factory = /** @class */ (function () {
    function LiquidityHelper__factory() {
    }
    LiquidityHelper__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    LiquidityHelper__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    LiquidityHelper__factory.abi = _abi;
    return LiquidityHelper__factory;
}());
exports.LiquidityHelper__factory = LiquidityHelper__factory;
//# sourceMappingURL=LiquidityHelper__factory.js.map